import addToCartService from '../services/rbata.addToCartService';
import Breakpoints from 'breakpoints-js/src/breakpoints';
import logger from '../utils/rbata.logger';
import {Bloomreach} from '../utils/bloomreach';

const crossSellingComponent = {
    miniCartSelector: '.miniCart__wrapper',
    cartSelector:     '#cart-page',
    // in the mobile view, the cross-selling component must be displayed at a different position in the minicart
    miniCartCarouselId:           'js-minicart__cross-selling',
    crossSellingFeatureSelector:  '.js-cross-selling__feature',
    $miniCartCrossSellingFeature: undefined,
    $cartCrossSellingFeature:     undefined,
    itemsContainerSelector:       '.js-cross-selling__items',
    itemSelector:                 '.js-cross-selling__item',
    sizeSelector:                 'select.js-cross-selling__select',
    sliderSelector:               '.js-cross-selling__slider',
    buttonSelector:               '.js-cross-selling__button',
    priceSelector:                '.js-cross-selling__price',
    errorsSelector:               '.js-cross-selling__errors',
    miniCartSilent:               false,

    getItemsBaseIds($object) {
        // Eliminate duplicated base products and return array of base product codes
        return [...new Set($object.map((_, el) => $(el).data('base')).get())]
    },

    miniCartInit(silent = false) {
        this.miniCartSilent = silent
        this.$miniCartCrossSellingFeature = $(`${this.miniCartSelector} ${this.crossSellingFeatureSelector}`);

        if (this.$miniCartCrossSellingFeature.length) {
            const cartItems = this.getItemsBaseIds($('.miniCart__item[data-base]'));
            const currentProduct = window.location.href.match(/\/(ATA\d+)\//)?.[1];
            if (!cartItems.includes(currentProduct) && currentProduct) {
                cartItems.push(currentProduct);
            }
            if (this.miniCartSilent) {
                this.$miniCartCrossSellingFeature.show();
            }
            Bloomreach.fetchPersonalizedProducts(this.$miniCartCrossSellingFeature.data('config'), cartItems, this.enrichMiniCartProducts);
        } else {
            logger.log('no cross-selling component on minicart maintained');
            this.$miniCartCrossSellingFeature.remove();
        }
    },

    cartInit() {
        this.$cartCrossSellingFeature = $(`${this.cartSelector} ${this.crossSellingFeatureSelector}`);

        if (this.$cartCrossSellingFeature.length) {
            const cartItems = this.getItemsBaseIds($('.cart__item[data-base]'));
            Bloomreach.fetchPersonalizedProducts(this.$cartCrossSellingFeature.data('config'), cartItems, this.enrichCartProducts);
        } else {
            logger.log('no cross-selling component on cart maintained');
            this.$cartCrossSellingFeature.remove();
        }
    },

    enrichMiniCartProducts(products) {
        crossSellingComponent.enrichProducts(products, crossSellingComponent.$miniCartCrossSellingFeature);
    },

    enrichCartProducts(products) {
        crossSellingComponent.enrichProducts(products, crossSellingComponent.$cartCrossSellingFeature);
    },

    enrichProducts(products, $container) {
        if (!products?.length) {
            return;
        }
        const componentId = ($container.data('config')).compUid;
        const productIds = products?.map(item => item.product_id ?? '');
        return $.ajax({
            url:         Bloomreach.getCrossSellingUrl(componentId, productIds),
            method:      'POST',
            cache:       false,
            processData: false,
            contentType: false
        }).done((data) => {
            if (data) {
                crossSellingComponent.renderCrossSellingProducts(data, $container?.attr('id'));
                if (!this.miniCartSilent) {
                    $container.fadeIn('fast');
                }
                this.miniCartSilent = false;
            } else {
                $container.remove();
                if (this.$miniCartCrossSellingFeature && $container?.attr('id') === this.$miniCartCrossSellingFeature?.attr('id')) {
                    $(`#${this.miniCartCarouselId}`).remove();
                }
            }
        }).fail((jqXHR) => {
            $container.remove();
            logger.error(`${jqXHR.status} error in bloomreach product enrichment request`)
        });
    },

    renderCrossSellingProducts(fragment, carouselId) {
        // the hardcoded cross-selling carousel in the minicart has a different position on mobile view
        if (carouselId === this.$miniCartCrossSellingFeature?.attr('id')) {
            $('#js-minicart__cross-selling-title').html($(`#${carouselId} .js-cross-selling__title`).html());
            $('#js-minicart__cross-selling-items').html(fragment);
            this.initImageSliders(this.miniCartCarouselId);
            this.buildSelectMenu(this.miniCartCarouselId);
        }

        $(`#${carouselId} ${this.itemsContainerSelector}`).html(fragment);
        this.initImageSliders(carouselId);
        this.buildSelectMenu(carouselId);

    },

    initImageSliders(carouselId) {
        $(`#${carouselId} ${this.sliderSelector}`).each((index, element) => {
            const controls = $(element)
                    .closest(this.itemSelector)
                    .find('.js-cross-selling__controls');

            tns({
                container:         element,
                mode:              'gallery',
                speed:             alphatauri.config.sliderProductTileSlideAnimation ?? 300,
                controls:          true,
                controlsContainer: controls[0],
                mouseDrag:         true
            })

            $(this.itemSelector).on('click', '.cross-selling__arrow, .tns-nav', function (evt) {
                evt.stopPropagation();
                evt.preventDefault();
            });
        });

    },

    buildSelectMenu(carouselId) {
        $(`#${carouselId} ${this.sizeSelector}`).selectpicker({
            style: 'btn-sm', dropupAuto: true
        }).on('changed.bs.select', (evt, clickedIndex) => {
            const dataset = evt.currentTarget.options[clickedIndex].dataset;
            $(evt.currentTarget)
                    .closest(this.itemSelector)
                    .find(this.sizeSelector)
                    .selectpicker('setStyle', 'is-invalid', 'remove')
                    .end()
                    .find(this.errorsSelector)
                    .empty()
                    .end()
                    .find(this.buttonSelector)
                    .attr('data-code', dataset.code)
                    .find(this.priceSelector)
                    .html(this.renderPrice(dataset));
        }).on('loaded.bs.select', (evt) => {
            // In case first product is not in stock
            const currentPicker = $(evt.currentTarget);
            const currentOptionCode = currentPicker.find('option:selected').data('code');
            currentPicker.parents(this.itemSelector).find(this.buttonSelector).attr('data-code', currentOptionCode)
        });
    },

    bindButtonHandler() {
        $(document).on('click', this.buttonSelector, (evt) => {
            const currentTarget = evt.currentTarget;
            // page reload on the cart page
            const reload = !!$(currentTarget).closest(this.cartSelector).length
            const dataset = currentTarget.dataset
            if (!dataset.code) {
                $(currentTarget)
                        .closest(this.itemSelector)
                        .find(this.sizeSelector)
                        .selectpicker('setStyle', 'is-invalid', 'add');
                return;
            }
            addToCartService.addToCart(dataset.url, dataset.code, this.clearLocalErrorMessages(currentTarget),
                    this.renderLocalErrorMessages(currentTarget), undefined, reload);
        });
    },

    renderPrice(dataset) {
        const price = dataset.discountedPrice === '' ? dataset.price : dataset.discountedPrice;

        if (dataset.oldPrice === '' || dataset.oldPrice === price) {
            return (`<span>${price}</span>`);
        } else {
            return (`<span>${price}</span><s>${dataset.oldPrice}</s>`);
        }
    },

    renderLocalErrorMessages(currentTarget) {
        const $errorContainer = $(currentTarget)
                .closest(this.itemSelector)
                .find(this.errorsSelector);

        return (errors) => {
            $.each(errors, (index, element) => {
                $errorContainer.append(`<div>${element}</div>`);
            });
        }
    },

    clearLocalErrorMessages(currentTarget) {
        const $errorContainer = $(currentTarget)
                .closest(this.itemSelector)
                .find(this.errorsSelector);

        return () => {
            $errorContainer.empty();
        }
    }
}

$(() => {
    crossSellingComponent.bindButtonHandler();
});

export default crossSellingComponent;
